import React, { FC } from 'react';
import { LinkProps } from 'react-router-dom';
import { LinkStyled } from './Link.styles';

const Link: FC<LinkProps<any>> = props => {
  return <LinkStyled {...props} />;
};

export default Link;
